module.exports = __webpack_public_path__ + "static/01-b42b8029c41732c85e9a49d1d5e2170b.png";